<template>
  <div class="mobile_videoTutorial_warp">
    <myHeader />
    <p class="videoTuorial_title" style="font-size:26px">hecoos tutorial videos</p>
    <div class="videoTutorial_tab">
      <button :class="{ active: isActive === 0 }" @click="changeTab(0)">Function</button>
      <button :class="{ active: isActive === 1 }" @click="changeTab(1)">Application</button>
      <button :class="{ active: isActive === 2 }" @click="changeTab(2)"> "X-R" Chapter </button>
    </div>
    <div class="videoTutorial_content" v-if="list.length">
      <div class="video_item" v-for="(item, index) in list" :key="index">
        <p class="p_title" v-html="item.title"></p>
        <div class="image-container">
          <img :src="baseUrl + item.cover" alt="">
          <div class="item_button" @click="showVideo(item)">
            <div class="play_icon"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="no_data" v-else>
      <p>No data!!!</p>
    </div>
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
import { getVideoList } from "@/api/api";

export default {
  components: { myHeader, myFooter, videoPlayback },
  data() {
    return {
      showVideoPlayer: false,
      videoUrl: '',
      baseUrl: "https://www.hecoos.com/",
      isActive: 0,
      applicationList: [],
      functionList: [],
      xrList: [],
      list: [],
    };
  },
  created() {
    this.getVideoLists();
  },
  methods: {
    changeTab(tab) {
      this.isActive = tab;
      if (tab === 0) {
        this.list = this.functionList;
      } else if (tab === 1) {
        this.list = this.applicationList;
      } else if (tab === 2) {
        this.list = this.xrList;
      }
    },
    getVideoLists() {
      getVideoList().then((res) => {
        this.applicationList = res.data.applicationList || [];
        this.functionList = res.data.functionList || [];
        this.xrList = res.data.xrList || [];
        this.list = this.functionList;
      });
    },
    showVideo(msg) {
      this.videoUrl = msg.youtube;
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden';
    },
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto';
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_videoTutorial_warp {
  background-color: #000;

  .videoTuorial_title {
    font-size: 32px;
    color: #fff;
    text-align: center;
    margin-top: 20px;
  }

  .videoTutorial_tab {
    width: 100%;
    margin-top: 16px;
    text-align: center;

    button {
      border: none;
      background-color: #000;
      color: #fff;
      font-size: 14px;
      margin: 0 16px;
      padding: 5px 3px;
    }

    .active {
      border-bottom: 2px solid #147cf5;
    }
  }

  .videoTutorial_content {
    width: 100%;
    margin-top: 20px;
    background-color: #fff;
    padding: 30px 40px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 15px;

    .video_item {
      .p_title {
        font-size: 16px;
        color: #000;
        margin: 20px 0 5px;
      }

      .image-container {
        position: relative;
        display: inline-block;

        img {
          width: 100%;
          max-width: 416px;
          max-height: 214.6px;
          display: block;
        }

        .item_button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 64px;
          height: 64px;
          border: 2px solid #fff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .play_icon {
            width: 20px;
            height: 20px;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 15px solid #fff;
            transform: translateX(5px);
          }
        }
      }
    }
  }

  .no_data {
    text-align: center;
    height: calc(100vh - 552px);
    font-size: 54px;
    color: #333333;
    background-color: #fff;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (min-width: 768px){
  .mobile_videoTutorial_warp {
  background-color: #000;

  .videoTuorial_title {
    font-size: 50px !important;
    color: #fff;
    text-align: center;
    margin-top: 20px;
  }

  .videoTutorial_tab {
    width: 100%;
    margin-top: 16px;
    text-align: center;

    button {
      border: none;
      background-color: #000;
      color: #fff;
      font-size: 26px;
      margin: 0 16px;
      padding: 5px 3px;
    }

    .active {
      border-bottom: 2px solid #147cf5;
    }
  }

  .videoTutorial_content {
    width: 100%;
    margin-top: 20px;
    background-color: #fff;
    padding: 30px 40px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 15px;

    .video_item {
      width: 100%;

      .p_title {
        font-size: 26px;
        text-align: center;
        color: #000;
        margin: 20px 0 5px;

      }

      .image-container {
        position: relative;
        display: inline-block;

        width: 100%;
        img {
          width: 100%;
          max-width: 100% ;
          max-height: 500px;
          display: block;
        }

        .item_button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 64px;
          height: 64px;
          border: 2px solid #fff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .play_icon {
            width: 20px;
            height: 20px;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 15px solid #fff;
            transform: translateX(5px);
          }
        }
      }
    }
  }

  .no_data {
    text-align: center;
    height: calc(100vh - 552px);
    font-size: 54px;
    color: #333333;
    background-color: #fff;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
}
</style>
